(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-count"] && !Shopify.designMode) return;
  try {
    // Single source of truth for the cart badge. The product form and cart page
  // call this after an AJAX cart change so the header, drawer and cart title all
  // show the same number. Rendered in the header → available on every page.
  if (!window.setCartCount) {
    window.setCartCount = function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.toggleAttribute('hidden', Number(count) === 0);
      });
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-discount')) {
    customElements.define(
      'cart-discount',
      class CartDiscount extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-discount-dialog]');
          this.input = this.querySelector('[data-discount-input]');
          this.dialogInput = this.querySelector('[data-discount-dialog-input]');
          this.body = this.querySelector('#cart-discount-body');
          this.toggle = this.querySelector('[data-discount-toggle]');
          this.applied = this.querySelector('[data-discount-applied]');
          this.appliedLabel = this.querySelector('[data-discount-applied-label]');
          this.codeSlot = this.querySelector('[data-discount-code]');
          this.inlineError = this.querySelector('[data-discount-inline-error]');
          this.dialogError = this.querySelector('[data-discount-error]');
          this.applyButton = this.querySelector('[data-discount-apply]');
          this.dialogApplyButton = this.querySelector('[data-discount-dialog-apply]');
          this.removeButton = this.querySelector('[data-discount-remove]');
          this.checkoutUrl = this.dataset.checkoutUrl;
          this.activeCode = this.dataset.activeCode || '';

          this.toggle.addEventListener('click', () => this.setOpen(this.body.hidden));
          this.applyButton.addEventListener('click', () => this.applyInline());
          this.dialogApplyButton.addEventListener('click', () => this.applyFromDialog());
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.applyInline();
            }
          });
          this.dialogInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.applyFromDialog();
            }
          });
          this.removeButton.addEventListener('click', () => this.remove());
          this.querySelector('[data-discount-dismiss]').addEventListener('click', () => this.dialog.close());
          this.querySelector('[data-discount-skip]').addEventListener('click', () => {
            this.dialog.close();
            this.proceed();
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.bindCheckout();
          this.sync();
        }

        // De afreken-knop staat buiten dit element, elders in de totalenbox.
        bindCheckout() {
          const root = this.closest('cart-items') || document;
          this.checkoutButton = root.querySelector('.cart__checkout');
          if (!this.checkoutButton) return;
          this.checkoutButton.addEventListener('click', (event) => {
            if (this.activeCode) return; // er staat al een code: niet nog eens vragen
            event.preventDefault();
            this.dialogError.hidden = true;
            this.dialog.showModal();
          });
        }

        // Volgt de knop zoals die bedoeld was: een link volgen, of het
        // winkelwagenformulier indienen met name="checkout".
        proceed() {
          const button = this.checkoutButton;
          if (!button) return;
          if (button.tagName === 'A') {
            window.location.href = button.getAttribute('href');
          } else if (button.form) {
            button.form.requestSubmit(button);
          }
        }

        // Zet (of wist, met een lege string) de kortingscode op de winkelwagen
        // en geeft terug welke codes Shopify er daarna op heeft staan.
        async setDiscount(code) {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code }),
          });
          if (!response.ok) throw new Error('discount update failed');
          this.cart = await response.json();
          return CartDiscount.codesFrom(this.cart);
        }

        // Korting telt mee voor het minimale bestelbedrag: na het toepassen kan
        // de winkelwagen er dus onder zakken.
        belowMinimum() {
          const helper = window.DRGAdditionalOrder;
          return Boolean(helper && this.cart) && helper.qualifyingAmount(this.cart) < helper.MINIMUM_CENTS;
        }

        static codesFrom(cart) {
          const codes = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
          return codes.filter((entry) => entry && entry.code);
        }

        // 'applied' als Shopify de code accepteert. Een code die niet geldt
        // halen we weer weg, zodat de winkelwagen schoon blijft.
        async tryCode(rawCode) {
          const code = (rawCode || '').trim().toUpperCase();
          if (!code) return 'empty';
          const codes = await this.setDiscount(code);
          if (codes.some((entry) => entry.applicable !== false)) return 'applied';
          await this.setDiscount('');
          return 'invalid';
        }

        async attempt(input, errorElement, button) {
          errorElement.hidden = true;
          button.disabled = true;
          let outcome;
          try {
            outcome = await this.tryCode(input.value);
          } catch (error) {
            outcome = 'failed';
          }
          button.disabled = false;
          if (outcome === 'applied') {
            this.activeCode = input.value.trim().toUpperCase();
            return true;
          }
          const messages = {
            empty: this.dataset.textEmpty,
            invalid: this.dataset.textInvalid,
            failed: this.dataset.textFailed,
          };
          errorElement.textContent = messages[outcome];
          errorElement.hidden = false;
          input.focus();
          return false;
        }

        // De totalen komen uit Liquid; herladen toont de korting als regel.
        async applyInline() {
          if (await this.attempt(this.input, this.inlineError, this.applyButton)) window.location.reload();
        }

        // Zakt de winkelwagen door de korting onder het minimum, dan blijft de
        // klant hier: de herladen pagina toont de code en wat er nog bij moet.
        async applyFromDialog() {
          if (!(await this.attempt(this.dialogInput, this.dialogError, this.dialogApplyButton))) return;
          if (this.belowMinimum()) {
            window.location.reload();
            return;
          }
          this.dialog.close();
          this.proceed();
        }

        async remove() {
          this.removeButton.disabled = true;
          try {
            await this.setDiscount('');
            window.location.reload();
          } catch (error) {
            this.removeButton.disabled = false;
          }
        }

        setOpen(open) {
          this.body.hidden = !open;
          this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        // Een code kan ook via een link of een ander tabblad op de winkelwagen
        // staan, of juist verlopen zijn; daarom na het laden altijd gelijktrekken.
        async sync() {
          try {
            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) =>
              r.json()
            );
            this.render(CartDiscount.codesFrom(cart));
          } catch (error) {
            /* netwerkfout: de stand uit Liquid blijft staan */
          }
        }

        render(codes) {
          this.activeCode = codes.map((entry) => entry.code).join(', ');
          if (!this.activeCode) {
            this.applied.hidden = true;
            this.toggle.hidden = false;
            return;
          }
          const applicable = codes.some((entry) => entry.applicable !== false);
          this.codeSlot.textContent = this.activeCode;
          this.appliedLabel.textContent = applicable ? this.dataset.textApplied : this.dataset.textNotApplicable;
          this.applied.classList.toggle('discount__applied--pending', !applicable);
          this.applied.hidden = false;
          this.toggle.hidden = true;
          this.setOpen(false);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('menu-drawer')) {
    customElements.define(
      'menu-drawer',
      class MenuDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.toggle = this.querySelector('[data-drawer-open]');
          if (!this.dialog || !this.toggle) return;

          this.toggle.addEventListener('click', () => this.open());

          this.dialog.querySelectorAll('a[href]').forEach((link) =>
            link.addEventListener('click', () => {
              this.restoreFocusOnClose = false;
              this.dialog.close();
            })
          );

          this.querySelectorAll('[data-drawer-close]').forEach((btn) =>
            btn.addEventListener('click', () => this.dialog.close())
          );

          // Click on the backdrop (outside the panel box) closes the drawer.
          this.dialog.addEventListener('click', (event) => {
            const rect = this.dialog.getBoundingClientRect();
            const inside =
              event.clientX >= rect.left &&
              event.clientX <= rect.right &&
              event.clientY >= rect.top &&
              event.clientY <= rect.bottom;
            if (!inside) this.dialog.close();
          });

          // Native <dialog> traps focus and closes on Esc; just sync aria
          // state and return focus to the toggle when it closes.
          this.dialog.addEventListener('close', () => {
            this.toggle.setAttribute('aria-expanded', 'false');
            if (this.restoreFocusOnClose) this.toggle.focus();
            this.restoreFocusOnClose = true;
          });
        }

        open() {
          this.restoreFocusOnClose = true;
          this.dialog.showModal();
          this.toggle.setAttribute('aria-expanded', 'true');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form-script"] && !Shopify.designMode) return;
  try {
    // Format an integer amount of cents using the store's money_format string
  // (e.g. a euro symbol followed by an amount placeholder). Currency-agnostic:
  // the format comes from Shopify, so this never hardcodes symbol/separator/locale.
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var value = '';
    switch ((format.match(placeholder) || [])[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2, ',', '.'); // 'amount'
    }
    return format.replace(placeholder, value);
  }

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[type="submit"]');
          this.note = this.querySelector('[data-add-note]');
          if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));

          // Price/badge/unit-label live outside <product-form> (siblings in
          // .product__info, rendered once above the form) — scope lookups to
          // that shared container instead of `document` so this still works
          // correctly if more than one product block is ever on a page.
          this.scope = this.closest('.product__info') || this;
          this.variantSelect = this.querySelector('[data-variant-select]');
          const variantDataEl = this.querySelector('[data-variant-data]');
          this.variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : {};
          this.priceWrap = this.scope.querySelector('[data-price-wrap]');
          this.offerBadge = this.scope.querySelector('[data-offer-badge]');
          this.unitLabel = this.scope.querySelector('[data-unit-label]');
          this.soldoutNote = this.querySelector('[data-soldout-note]');
          this.continueBtn = this.querySelector('[data-continue-shopping]');

          // Live total = quantity × unit price of the selected variant (weight).
          this.moneyFormat = this.dataset.moneyFormat || ('${' + '{amount}}');
          this.quantityInput = this.form && this.form.querySelector('input[name="quantity"]');
          this.currentData = this.variantData[this.getSelectedVariantId()] || null;

          if (this.variantSelect) {
            this.variantSelect.addEventListener('change', () => this.onVariantChange());
          }
          if (this.quantityInput) {
            // The stepper fires `change`; typing fires `input` — react to both.
            this.quantityInput.addEventListener('change', () => this.applyQuantity());
            this.quantityInput.addEventListener('input', () => this.applyQuantity());
          }
          if (this.continueBtn) {
            this.continueBtn.addEventListener('click', () => this.continueShopping());
          }
        }

        // "Verder winkelen": return to the page the shopper came from. Falls back
        // to the home page when there is no same-origin referrer (e.g. deep link).
        continueShopping() {
          const ref = document.referrer;
          if (ref && ref.indexOf(window.location.origin) === 0) {
            history.back();
          } else {
            window.location.href = window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root
              : '/';
          }
        }

        // Reset the quantity to its minimum so a count picked for one variant
        // (e.g. 2 stuks) never silently carries over to another (e.g. kilo's).
        resetQuantity() {
          if (!this.quantityInput) return;
          this.quantityInput.value = this.quantityInput.min || 1;
        }

        getSelectedVariantId() {
          const idInput = this.form && this.form.querySelector('[name="id"]');
          return idInput ? idInput.value : null;
        }

        onVariantChange() {
          const data = this.variantData[this.variantSelect.value];
          if (!data) return;
          this.currentData = data;

          // priceHtml is the unit price (qty 1); re-scale to the current qty below.
          if (this.priceWrap) this.priceWrap.innerHTML = data.priceHtml;
          if (this.offerBadge) this.offerBadge.hidden = !data.onSale;
          if (this.unitLabel) {
            this.unitLabel.textContent = data.unitLabel;
            this.unitLabel.hidden = !data.unitLabel;
          }
          if (this.soldoutNote) this.soldoutNote.hidden = data.available;
          if (this.button) this.button.disabled = !data.available;

          this.resetQuantity();
          this.applyQuantity();
        }

        applyQuantity() {
          const data = this.currentData;
          if (!data || !this.priceWrap) return;

          const raw = parseInt(this.quantityInput && this.quantityInput.value, 10);
          const qty = raw > 0 ? raw : 1;

          const currentEl = this.priceWrap.querySelector('.price__current');
          if (currentEl && typeof data.price === 'number') {
            currentEl.innerHTML = formatMoney(data.price * qty, this.moneyFormat);
          }
          const compareEl = this.priceWrap.querySelector('.price__compare');
          if (compareEl && typeof data.compareAt === 'number') {
            compareEl.innerHTML = formatMoney(data.compareAt * qty, this.moneyFormat);
          }
        }

        async onSubmit(event) {
          event.preventDefault();
          this.setBusy(true);
          try {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(this.form),
            });
            if (!addRes.ok) throw new Error('add failed');

            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(
              (r) => r.json()
            );
            if (window.setCartCount) window.setCartCount(cart.item_count);
            this.flash(this.note && this.note.dataset.success, false);
            // Lets a wrapping <quick-add-dialog> auto-close on success without
            // this element needing to know dialogs exist.
            this.dispatchEvent(new CustomEvent('product-form:added', { bubbles: true }));
          } catch (error) {
            this.flash(this.note && this.note.dataset.error, true);
          } finally {
            this.setBusy(false);
          }
        }

        setBusy(busy) {
          if (!this.button) return;
          this.button.disabled = busy;
          this.button.toggleAttribute('aria-busy', busy);
        }

        flash(message, isError) {
          if (this.continueBtn) this.continueBtn.hidden = isError;
          if (!this.note || !message) return;
          this.note.textContent = message;
          this.note.hidden = false;
          this.note.style.color = isError ? 'var(--color-highlight)' : 'var(--color-primary)';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          if (!this.input) return;
          this.addEventListener('click', (event) => {
            const stepEl = event.target.closest('[data-qty-step]');
            if (stepEl) this.step(Number(stepEl.dataset.qtyStep));
          });
        }

        step(direction) {
          const min = Number(this.input.min) || 0;
          const max = this.input.max === '' ? Infinity : Number(this.input.max);
          const current = Number(this.input.value) || min;
          const next = Math.max(min, Math.min(max, current + direction));
          if (next !== current) {
            this.input.value = next;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-add-dialog')) {
    customElements.define(
      'quick-add-dialog',
      class QuickAddDialog extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.content = this.querySelector('[data-quick-add-content]');
          if (!this.dialog || !this.content) return;

          // Event-delegated: triggers live inside every product card, not
          // inside this element, so listen on the document. The trigger sits
          // inside the card's <a href="product.url">, so without stopping
          // the event here the click would bubble up and navigate to the
          // product page instead of opening the popup.
          document.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-quick-add-trigger]');
            if (!trigger) return;
            event.preventDefault();
            event.stopPropagation();
            this.openFor(trigger);
          });

          this.querySelectorAll('[data-quick-add-close]').forEach((btn) =>
            btn.addEventListener('click', () => this.dialog.close())
          );

          this.dialog.addEventListener('click', (event) => {
            const rect = this.dialog.getBoundingClientRect();
            const inside =
              event.clientX >= rect.left &&
              event.clientX <= rect.right &&
              event.clientY >= rect.top &&
              event.clientY <= rect.bottom;
            if (!inside) this.dialog.close();
          });

          // Auto-close on a successful add (bubbles up from the cloned
          // <product-form> once /cart/add.js succeeds).
          this.content.addEventListener('product-form:added', () => this.dialog.close());

          // Native <dialog> traps focus and closes on Esc; just empty the
          // content afterwards so the next open starts from a clean clone
          // (avoids stale duplicate-id form state from the previous product).
          this.dialog.addEventListener('close', () => {
            this.content.innerHTML = '';
          });
        }

        openFor(trigger) {
          const templateId = trigger.dataset.quickAddTrigger;
          const template = document.getElementById(templateId);
          if (!template) return;

          this.content.innerHTML = '';
          this.content.appendChild(template.content.cloneNode(true));
          this.dialog.showModal();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
